import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { SettingPermissionsService } from '@core/services';
import { redirectToAccessDenied } from '@shared/utilities';
import { BISettingsPermissionsScreenCodes } from '@shared/common/permissionsList.enum';

@Component({
  selector: 'z-settings',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsComponent {
  readonly #settingsService = inject(SettingPermissionsService);
  readonly #router = inject(Router);
  readonly #destroyRef = inject(DestroyRef);

  constructor() {
    const sub = this.#settingsService.settingScreensPermissions$.subscribe(
      permissions => {
        const pagePermissions = permissions.filter(x => x.canView);
        if (pagePermissions.length === 0) {
          redirectToAccessDenied(this.#router);
          return;
        }

        if (
          pagePermissions[0].screenCode ===
          BISettingsPermissionsScreenCodes.UsersAndPermissions
        ) {
          this.#router.navigate(['bi-settings/users-and-permissions']);
        } else {
          this.#router.navigate(['bi-settings/dashboards-settings']);
        }
      },
    );

    this.#destroyRef.onDestroy(() => sub.unsubscribe());
  }
}
